import React from "react";
import { useLanguage } from "../components/Language.js";
import {BASE_URL} from "../constants"

const SmartphoneTab = () => {

  const {language} = useLanguage();
  
  return (
    <div>
      {language === "en" ? (
        <>
          <h2>Using Gaelic Connect on Your Smartphone</h2>
          <p>Gaelic Connect also works on your phone! You can save the site to your smart phone’s home screen. 
            This creates an icon on your home screen that links to the site, so that you can access the site when 
            you are out and about. The following instructions describe how to do this using Chrome for Android and 
            Safari for iPhone.</p>

          <p>If you are using Android:</p>
          <ol>
            <li>Open Chrome (or your preferred browser)</li>
            <li>Go to gaelicconnect.org</li>
            <li>Tap the menu icon (usually three dots in top-right corner)</li>
            <li>From the menu, select <b>Add to Home Screen</b></li>
            <li>If prompted, choose a name for the shortcut </li>
            <li>Tap <b>Add</b></li>
          </ol>

          <p>If you are using iPhone:</p>
          <ol>
            <li>Open the Safari browser</li>
            <li>Go to gaelicconnect.org</li>
            <li>Tap the <b>Share</b> icon (square with arrow)</li>
            <li>Scroll down and tap <b>Add to Home Screen</b></li>
            <li>Choose a name for the shortcut </li>
            <li>Tap <b>Add</b></li>
          </ol>

          <h4>More Information</h4>
          <p>You can always come back to this information page to refresh your memory by clicking on the book 
            icon in the bottom right of the map screen. Have fun using Gaelic Connect!</p>

        </>
      ) : (
        <>
          <h2>Cleachdadh Ceangal Gàidhlig air Clis-fòn</h2>
          <p>Tha Ceangal Gàidhlig ag obrachadh cuideachd air an fhòn agad! Faodaidh tu an làrach a shàbhaladh 
            gu sgrìn dachaigh an fhòn-chlis agad. Tha seo a’ cruthachadh ìomhaigh air an sgrìn dachaigh agad a 
            tha a’ ceangal ris an làraich, gus am faod thu faighinn a-steach don làraich nuair a bhios tu 
            a-muigh ’s mun cuairt. Tha na stiùiridhean a leanas a’ toirt iomradh air an dòigh air seo a dhèanamh 
            a’ cleachdadh Chrome airson Android agus Safari airson iFòn. </p>

          <p>Ma tha thu a’ cleachdadh Android:</p>
          <ol>
            <li>Fosgail Chrome (no am brobhsair as fheàrr leat)</li>
            <li>Theirig gu gaelicconnect.org </li>
            <li>Put ìomhaigh a’ chlàir-iùil (gu h-àbhaisteach trì dotagan san oisean dheas gu h-àrd)</li>
            <li>Bhon chlàr-iùil, tagh <b>Cuir Ris an Sgrìn Dachaigh</b></li>
            <li>Ma dh’iarrar, tagh ainm airson an aithghearra</li>
            <li>Put <b>Cuir Ris</b></li>
          </ol>

          <p>Ma tha thu a’ cleachdadh iFòn:</p>
          <ol>
            <li>Fosgail brobhsair Safari</li>
            <li>Theirig gu gaelicconnect.org </li>
            <li>Put air ìomhaigh <b>Roinn</b> (ceàrnagach le saighead)</li>
            <li>Sgrolaig sìos agus put <b>Cuir Ri Sgrìn Dachaigh</b></li>
            <li>Tagh ainm don aithghearra</li>
            <li>Put <b>Cuir Ris</b></li>
          </ol>

          <h4>Tuilleadh fiosrachaidh</h4>
          <p>Faodaidh tu an-còmhnaidh tilleadh air ais gu an duilleag fiosrachaidh seo gus do 
            chuimhne ùrachadh le cliogadh air an ìomhaigh leabhair san oisean dheas gu h-ìosal 
            air sgrìn a’ mhapa. Biodh spòrs agad a’ cleachdadh Ceangal Gàidhlig! </p>

        </>
      )}
    </div>
  );
};

export default SmartphoneTab;
